import { render, staticRenderFns } from "./ModalFinalApproval.vue?vue&type=template&id=606d3f32&"
import script from "./ModalFinalApproval.vue?vue&type=script&lang=js&"
export * from "./ModalFinalApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports